<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="flex flex-row items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
    >
      <circle
        cx="51"
        cy="51"
        r="51"
        fill="url(#paint0_radial_1168_1935)"
      />
      <circle
        cx="51"
        cy="51"
        r="51"
        fill="url(#paint1_radial_1168_1935)"
      />
      <path
        class="wave wave1 relative"
        d="M1.5 51.0001C23.7516 32.5781 35.5853 31.6397 56 47.0001C57.7486 48.3158 59.4189 49.5108 61.0204 50.5897C75.3878 44.8436 87.8769 46.0762 100.5 51.0001C87.4508 60.3849 78.1935 62.1598 61.0204 50.5897C55.4961 52.7991 49.6941 56.0403 43.5 60.5C31 69.5 15.6013 62.7719 1.5 51.0001Z"
        fill="url(#paint2_linear_1168_1935)"
        fill-opacity="0.33"
        stroke="url(#paint3_linear_1168_1935)"
      />
      <path
        class="wave wave2 relative"
        d="M1.5 51.0002C26.8796 40.7505 47.9125 33.373 69.8868 44.1751C80.7659 43.8326 90.8961 47.254 100.5 51.0002C91.5 54.5 87.5 53.5 71.5 45C70.9617 44.714 70.424 44.4391 69.8868 44.1751C60.9687 44.4559 51.5472 47.266 41.5 54.5C29 63.5 15.6013 62.772 1.5 51.0002Z"
        fill="url(#paint4_linear_1168_1935)"
        fill-opacity="0.33"
        stroke="url(#paint5_linear_1168_1935)"
      />
      <path
        class="wave wave3 relative"
        d="M1.5 51.0001C23.5 35.5 32.5 40.9999 42 44.4999C44.0123 45.2413 45.9405 46.2275 47.827 47.3511C59.7268 41.7837 82.3726 34.6853 100.5 51.0001C73.6102 71.7184 61.8777 55.7207 47.827 47.3511C46.5977 47.9263 45.4831 48.4851 44.5 49C30.8556 56.1471 15.6013 62.772 1.5 51.0001Z"
        fill="url(#paint6_linear_1168_1935)"
        fill-opacity="0.33"
        stroke="url(#paint7_linear_1168_1935)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_1168_1935"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(51 51) rotate(-90) scale(51)"
        >
          <stop
            stop-color="white"
            stop-opacity="0"
          />
          <stop
            offset="1"
            stop-color="#4F2B1B"
            stop-opacity="0.3"
          />
        </radialGradient>
        <radialGradient
          id="paint1_radial_1168_1935"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(51 51) rotate(-90) scale(51 61.3911)"
        >
          <stop
            offset="0.87"
            stop-color="white"
            stop-opacity="0"
          />
          <stop
            offset="0.975"
            stop-color="white"
            stop-opacity="0.4"
          />
          <stop
            offset="1"
            stop-color="white"
            stop-opacity="0.2"
          />
        </radialGradient>
        <linearGradient
          id="paint2_linear_1168_1935"
          x1="51"
          y1="36.264"
          x2="51"
          y2="64.6585"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EE9F3F" />
          <stop
            offset="0.505"
            stop-color="#6ABDE1"
          />
          <stop
            offset="1"
            stop-color="#EE9F3F"
          />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1168_1935"
          x1="51"
          y1="36.264"
          x2="51"
          y2="64.6585"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6ABDE1" />
          <stop
            offset="0.5"
            stop-color="#EE9F3F"
          />
          <stop
            offset="1"
            stop-color="#6ABDE1"
          />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1168_1935"
          x1="51"
          y1="38.8575"
          x2="51"
          y2="60.6204"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6ABDE1" />
          <stop
            offset="0.5"
            stop-color="#EE9F3F"
          />
          <stop
            offset="1"
            stop-color="#6ABDE1"
          />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1168_1935"
          x1="51"
          y1="38.8575"
          x2="51"
          y2="60.6204"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6ABDE1" />
          <stop
            offset="0.5"
            stop-color="#EE9F3F"
          />
          <stop
            offset="1"
            stop-color="#6ABDE1"
          />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1168_1935"
          x1="51"
          y1="40.62"
          x2="51"
          y2="61.1697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EE9F3F" />
          <stop
            offset="0.505"
            stop-color="#6ABDE1"
          />
          <stop
            offset="1"
            stop-color="#EE9F3F"
          />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1168_1935"
          x1="51"
          y1="40.62"
          x2="51"
          y2="61.1697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6ABDE1" />
          <stop
            offset="0.5"
            stop-color="#EE9F3F"
          />
          <stop
            offset="1"
            stop-color="#6ABDE1"
          />
        </linearGradient>
      </defs>
    </svg>
    <div class="voice-search-info ml-6 text-primary">
      <h2 class="text-xl mb-2 font-family-base font-medium">
        {{ t('voice_search_title') }}
      </h2>
      <p>
        ⚠️ <span class="opacity-50">{{ t('voice_search_hint') }}</span>
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@keyframes waveMotion {
  from {
    transform: rotateX(0);
  }
  to {
    transform: rotateX(360deg);
  }
}

@keyframes waveMotion2 {
  from {
    transform: rotateX(0);
  }
  to {
    transform: rotateX(-360deg);
  }
}

.wave {
    transform-origin: center;
    animation: waveMotion 5s linear infinite;
    &2 {
        animation-delay: .2s;
        animation: waveMotion2 5s linear infinite;
    }
    &3 {
        animation-delay: .8s;
    }
}
</style>

<i18n>
  {
    "cs": {
    "voice_search_hint": "Pro správné fungování musíte povolit této stránce užívat mikrofon na Vašem zařízení.",
    "voice_search_title": "Řekněte nám, jaké chroupání hledáte"
},
    "sk": {
    "voice_search_hint": "Pre správne fungovanie musíte povoliť tejto stránke užívať mikrofón na Vašom zariadení.",
    "voice_search_title": "Povedzte nám, aký druh chrumkavosti hľadáte"
},
    "pl": {
    "voice_search_hint": "Aby strona działała prawidłowo, musisz zezwolić jej na korzystanie z mikrofonu w Twoim urządzeniu.",
    "voice_search_title": "Powiedz nam, czego szukasz"
},
    "hu": {
    "voice_search_hint": "A megfelelő működéshez engedélyeznie kell, hogy ez az oldal használja a készülék mikrofonját.",
    "voice_search_title": "Mondja el nekünk, milyen rágcsálnivalót keres!"
},
    "de": {
    "voice_search_hint": "Für die korrekte Funktion musst du dieser Seite den Zugriff auf dein Mikrofon erlauben.",
    "voice_search_title": "Sage uns, welche Leckereien du suchst"
},
    "at": {
    "voice_search_hint": "Für die korrekte Funktion musst du dieser Seite den Zugriff auf dein Mikrofon erlauben.",
    "voice_search_title": "Sage uns, welche Leckereien du suchst"
},
    "ro": {
    "voice_search_hint": "Pentru funcționarea corectă, trebuie să permiteți acestei pagini să folosească microfonul de pe dispozitivul dumneavoastră.",
    "voice_search_title": "Spuneți-ne ce bunătăți crocante căutați"
}
  }
</i18n>